/**
 * Retorna el color de texto según el porcentaje de cumplimiento:
 * - 0–59  → rojo  (#ff4d4f)
 * - 60–84 → amarillo (#faad14)
 * - 85+   → turquesa (#00BFB3)
 */
export function getComplianceColor(value: number): string {
  if (value < 60) return '#ff4d4f';
  if (value < 85) return '#faad14';
  return '#00BFB3';
}
